let VoucherFactory = () => {
  // reduction: XX.XX% OR XX.XX OR FREE; priceProduct: 5.99 EUR
  let getReductionPrice = (reduction, priceProduct) => {
    let priceWithReduction = ''
    let currency = priceProduct.substring(priceProduct.indexOf(' '))
    if (reduction.toLowerCase() === 'free') {
      priceWithReduction = '0.00' + currency
    } else {
      let newPrice = 0
      if (reduction.endsWith('%')) {
        newPrice = parseFloat(priceProduct) * (1 - parseFloat(reduction) / 100)
      } else {
        newPrice = parseFloat(priceProduct) - parseFloat(reduction)
      }
      newPrice = Math.round(newPrice * 100) / 100
      if (newPrice <= 0) {
        priceWithReduction = '0.00' + currency
      } else {
        priceWithReduction = newPrice + currency
      }
    }
    return priceWithReduction
  }

  let validateCountryVoucher = (countryCode, countryVoucher) => {
    return countryCode.toUpperCase() === countryVoucher
  }

  let validateProductRefFromVoucher = (productList, productRef) => {
    return productList.indexOf(parseInt(productRef)) !== -1
  }

  return { getReductionPrice, validateCountryVoucher, validateProductRefFromVoucher }
}

export default VoucherFactory



// WEBPACK FOOTER //
// ./src/app/services/voucher/voucher.factory.js